/** 精选漫画推荐 */
export const cardsData = [
  {
    id: 1,
    title: '热血韩漫：竞技场王者归来',
    description: '从底层拳手到顶级竞技之王，每一步都是血与汗的淬炼。韩国热血漫的巅峰之作，画风凌厉，剧情燃爆。',
    tag: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20comic%20book%20cover%20art%20with%20martial%20arts%20fighter%20in%20arena%2C%20intense%20action%20scene%2C%20Korean%20manhwa%20style%2C%20vibrant%20orange%20and%20red%20color%20scheme%2C%20powerful%20composition%2C%20modern%20illustration&width=600&height=400&seq=card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '治愈日漫：夏目友人帐续篇',
    description: '温暖人心的妖怪物语再次开启，人与妖的羁绊在四季流转中愈加深厚。日漫治愈系的经典传承。',
    tag: '日漫',
    image: 'https://readdy.ai/api/search-image?query=Serene%20anime%20scene%20with%20gentle%20spirits%20and%20autumn%20leaves%2C%20soft%20pastel%20colors%2C%20Japanese%20manga%20healing%20aesthetic%2C%20peaceful%20countryside%20atmosphere%2C%20whimsical%20creatures%2C%20warm%20golden%20light&width=600&height=400&seq=card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫崛起：一人之下番外篇',
    description: '异人世界再起波澜，罗天大醮后的新篇章揭开神秘面纱。国产漫画精品，超能战斗与文化传承的完美融合。',
    tag: '国漫',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comic%20art%20with%20mystical%20martial%20arts%20and%20ancient%20Chinese%20culture%20elements%2C%20dynamic%20action%20pose%2C%20ink%20wash%20painting%20fusion%20with%20modern%20style%2C%20red%20and%20gold%20accents%2C%20epic%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑韩漫：消失的房间',
    description: '密闭空间中的连环谜案，每一扇门后都藏着不可告人的秘密。暗黑画风搭配烧脑推理，韩漫悬疑标杆之作。',
    tag: '韩漫',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20manhwa%20illustration%20with%20abandoned%20room%20interior%2C%20shadowy%20atmosphere%2C%20clues%20and%20puzzle%20elements%2C%20gothic%20style%2C%20deep%20purples%20replaced%20with%20warm%20browns%20and%20oranges%2C%20suspenseful%20composition&width=600&height=400&seq=card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '恋爱日漫：邻座同学的秘密',
    description: '青春校园的甜蜜日常，从邻座开始的悸动心跳。细腻的情感描绘让每一页都充满初恋的味道。',
    tag: '日漫',
    image: 'https://readdy.ai/api/search-image?query=Sweet%20romance%20anime%20illustration%20with%20high%20school%20students%20in%20classroom%2C%20soft%20cherry%20blossom%20colors%2C%20warm%20afternoon%20sunlight%2C%20gentle%20expressions%2C%20Japanese%20manga%20shoujo%20style%2C%20pink%20and%20cream%20tones&width=600&height=400&seq=card-05&orientation=landscape',
  },
];

/** 热度榜单 */
export const rankingData = [
  { rank: 1, title: '我独自升级', category: '韩漫', type: '动作奇幻', heat: 98 },
  { rank: 2, title: '咒术回战', category: '日漫', type: '热血战斗', heat: 95 },
  { rank: 3, title: '斗罗大陆', category: '国漫', type: '玄幻修真', heat: 93 },
  { rank: 4, title: '女神降临', category: '韩漫', type: '恋爱校园', heat: 91 },
  { rank: 5, title: '海贼王', category: '日漫', type: '冒险热血', heat: 90 },
  { rank: 6, title: '狐妖小红娘', category: '国漫', type: '恋爱古风', heat: 88 },
  { rank: 7, title: '全知读者视角', category: '韩漫', type: '穿越悬疑', heat: 86 },
];

/** 最新更新动态 */
export const updatesData = [
  { date: '2026.07.28', title: '《我独自升级》第二季第42话更新', tag: '韩漫', type: '连载更新' },
  { date: '2026.07.28', title: '《一人之下》番外篇第三章发布', tag: '国漫', type: '新章节' },
  { date: '2026.07.27', title: '《咒术回战》完结篇特别情报放出', tag: '日漫', type: '情报资讯' },
  { date: '2026.07.27', title: '《女神降临》番外篇甜蜜上线', tag: '韩漫', type: '番外更新' },
  { date: '2026.07.26', title: '《斗罗大陆》动画联动特别篇', tag: '国漫', type: '联动活动' },
  { date: '2026.07.25', title: '《全知读者视角》第187话汉化', tag: '韩漫', type: '汉化更新' },
  { date: '2026.07.25', title: '《间谍过家家》新篇章开启', tag: '日漫', type: '连载更新' },
  { date: '2026.07.24', title: '《狐妖小红娘》竹业篇动画化确认', tag: '国漫', type: '动画资讯' },
  { date: '2026.07.23', title: '《神之塔》第三季回归预告', tag: '韩漫', type: '回归预告' },
];

/** 联系入口 */
export const contactData = {
  title: '读者投稿与联系',
  description: '香蕉漫画网欢迎读者参与内容共建。如果你有优质漫画推荐、汉化资源投稿、纠错反馈，或希望与我们开展商务合作，欢迎通过以下方式联系。',
  methods: [
    { label: '漫画推荐投稿', desc: '推荐你认为值得关注的韩漫、日漫或国漫' },
    { label: '汉化资源合作', desc: '优秀的汉化组欢迎与我们建立长期合作' },
    { label: '纠错与反馈', desc: '发现内容错误或链接失效，请第一时间告知' },
    { label: '商务合作', desc: '广告投放、版权合作、活动联动等事宜' },
  ],
};

/** 读者评论 */
export const commentsData = [
  {
    id: 1,
    name: '漫迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20character%20portrait%20of%20a%20young%20male%20with%20glasses%2C%20warm%20expression%2C%20soft%20lighting%2C%20minimal%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    content: '香蕉漫画网的分类做得太细了！以前找韩漫要翻好几个站，现在一站搞定。更新速度也很快，基本同步韩国连载。',
    date: '2026.07.20',
    rating: 5,
  },
  {
    id: 2,
    name: '樱花漫友',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20female%20character%20portrait%20with%20long%20hair%2C%20garden%20setting%2C%20soft%20pastel%20colors%2C%20gentle%20smile%2C%20Japanese%20anime%20aesthetic&width=100&height=100&seq=avatar-02&orientation=squarish',
    content: '日漫区资源很全，从Jump新作到冷门佳作都有。最喜欢这个站的专题整理，每周都会根据主题推荐不同风格的漫画。',
    date: '2026.07.18',
    rating: 5,
  },
  {
    id: 3,
    name: '国漫拥护者',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20ink%20style%20character%20portrait%2C%20traditional%20clothing%2C%20artistic%20brushwork%20texture%2C%20warm%20earth%20tones%2C%20contemporary%20interpretation%20of%20classic%20art&width=100&height=100&seq=avatar-03&orientation=squarish',
    content: '国漫分类索引做得特别好，能按题材、年代、热度多重筛选。《一人之下》《狐妖小红娘》的专题合集整理得很用心。',
    date: '2026.07.15',
    rating: 4,
  },
  {
    id: 4,
    name: '追更狂魔',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20character%20portrait%20with%20energetic%20expression%2C%20modern%20casual%20outfit%2C%20urban%20background%2C%20comic%20book%20style%2C%20vibrant%20colors%2C%20dynamic%20pose&width=100&height=100&seq=avatar-04&orientation=squarish',
    content: '更新推送功能很实用，每次关注的漫画有新章节都会第一时间通知。韩漫汉化质量也在稳步提升，期待更多新作上架！',
    date: '2026.07.12',
    rating: 5,
  },
  {
    id: 5,
    name: '治愈系读者',
    avatar: 'https://readdy.ai/api/search-image?query=Serene%20anime%20character%20portrait%20with%20soft%20expression%2C%20cafe%20setting%2C%20warm%20afternoon%20light%2C%20relaxing%20atmosphere%2C%20cute%20animal%20companion%2C%20peaceful%20mood&width=100&height=100&seq=avatar-05&orientation=squarish',
    content: '非常喜欢这个站的专题策划，每期主题都很有品味。阅读体验也很干净，没有乱七八糟的弹窗广告，对漫迷非常友好。',
    date: '2026.07.10',
    rating: 5,
  },
];

/** 漫画分类索引 */
export const indexData = [
  { name: '热血战斗', count: 2847, icon: 'ri-fire-line', desc: '拳拳到肉的燃情对决' },
  { name: '恋爱校园', count: 3521, icon: 'ri-heart-3-line', desc: '青涩懵懂的青春物语' },
  { name: '悬疑推理', count: 1893, icon: 'ri-search-line', desc: '抽丝剥茧的烧脑谜案' },
  { name: '玄幻修真', count: 2156, icon: 'ri-magic-line', desc: '超凡入圣的仙侠传奇' },
  { name: '日常治愈', count: 2634, icon: 'ri-sun-line', desc: '平淡温暖的日常点滴' },
  { name: '科幻未来', count: 1432, icon: 'ri-rocket-line', desc: '穿越星际的科幻冒险' },
  { name: '历史古风', count: 1987, icon: 'ri-ancient-pavilion-line', desc: '穿越时空的历史画卷' },
  { name: '体育竞技', count: 1023, icon: 'ri-basketball-line', desc: '热血沸腾的赛场风云' },
];

/** 媒体推荐 */
export const mediaData = [
  {
    id: 1,
    title: '《我独自升级》动画化第二季PV',
    description: '现象级韩漫改编动画，第二季制作决定正式公开，全新冒险即将启程',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20anime%20promotional%20art%20with%20shadowy%20warrior%20figure%20and%20glowing%20aura%2C%20dark%20atmospheric%20background%2C%20action%20packed%20composition%2C%20Korean%20manhwa%20animation%20style%2C%20intense%20energy%20emanating&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《一人之下》电影版终极预告',
    description: '国漫巅峰之作登上大银幕，异人世界的终极对决震撼来袭',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animation%20promotional%20art%20with%20martial%20arts%20and%20supernatural%20elements%2C%20mystical%20energy%20swirls%2C%20traditional%20Chinese%20architecture%2C%20dynamic%20cinematic%20composition%2C%20golden%20and%20red%20accents&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '日漫新番导视：2026秋季档',
    description: 'Jump系与原创佳作齐聚，盘点最值得期待的十部秋季新番',
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20season%20preview%20art%20with%20multiple%20characters%20in%20dynamic%20poses%2C%20autumn%20leaves%20falling%2C%20Japanese%20anime%20promotional%20style%2C%20vibrant%20variety%20of%20colors%2C%20energetic%20composition&width=800&height=500&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '韩漫崛起：产业观察专题',
    description: '从Webtoon到全球现象，深度解析韩国漫画产业的崛起密码与未来趋势',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20webtoon%20industry%20illustration%20with%20smartphone%20and%20comic%20panels%2C%20Seoul%20cityscape%20background%2C%20digital%20art%20style%2C%20blue%20and%20coral%20tones%20with%20warm%20accents%2C%20creative%20composition%20showing%20art%20creation&width=800&height=500&seq=media-04&orientation=landscape',
  },
];

/** 焦点专题（一次性展示，无轮播） */
export const carouselData = [
  {
    id: 1,
    title: '穿越异世界专题',
    subtitle: '从平凡到传奇的异世界冒险',
    description: '精选20部优质异世界漫画，涵盖韩漫、日漫、国漫三大类型。从《关于我转生变成史莱姆这档事》到《全知读者视角》，带你领略不同作者笔下的异世界风情。',
    tag: '专题合集',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20otherworld%20landscape%20with%20floating%20islands%2C%20magical%20portals%2C%20epic%20scale%2C%20anime%20and%20manhwa%20fusion%20style%2C%20warm%20golden%20sunset%20lighting%2C%20diverse%20characters%20in%20distance%2C%20sense%20of%20adventure%2C%20dreamlike%20atmosphere&width=900&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '女性向恋爱精选',
    subtitle: '甜蜜暴击，心动每一页',
    description: '从霸道总裁到温柔学长，从校园暗恋到职场情缘。精选韩漫《女神降临》、日漫《月刊少女野崎君》、国漫《甜美的咬痕》等15部女性向恋爱佳作。',
    tag: '恋爱合集',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20illustration%20with%20couple%20in%20cherry%20blossom%20garden%2C%20soft%20pastel%20pink%20and%20white%20tones%2C%20shoujo%20manga%20aesthetic%2C%20dreamy%20atmosphere%2C%20gentle%20lighting%2C%20romantic%20comedy%20vibes%2C%20detailed%20background&width=900&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '国漫新势力',
    subtitle: '国产漫画的精品突围之路',
    description: '聚焦近年崛起的国产漫画新势力。《镖人》《镖人》《镇魂街》《刺客伍六七》等作品的深度解析，见证国漫从模仿到原创的蜕变之路。',
    tag: '国漫专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comic%20hero%20in%20traditional%20armor%20with%20modern%20urban%20backdrop%2C%20fusion%20of%20ancient%20and%20contemporary%2C%20dynamic%20action%20pose%2C%20red%20and%20gold%20color%20scheme%2C%20Chinese%20culture%20elements%2C%20cinematic%20composition%2C%20proud%20atmosphere&width=900&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '悬疑惊悚之夜',
    subtitle: '夜深人静时的极致恐惧',
    description: '当夜幕降临，正是阅读悬疑惊悚漫画的最佳时刻。从韩漫《他人即地狱》到日漫《富江》系列，精选12部让你心跳加速的悬疑惊悚作品。',
    tag: '惊悚专题',
    image: 'https://readdy.ai/api/search-image?query=Dark%20suspense%20horror%20illustration%20with%20mysterious%20shadow%20figure%20in%20abandoned%20street%2C%20moonlight%20and%20fog%2C%20psychological%20thriller%20atmosphere%2C%20dark%20crimson%20and%20black%20tones%2C%20gothic%20manhwa%20style%2C%20tense%20mood%2C%20unsettling%20but%20artistic&width=900&height=500&seq=carousel-04&orientation=landscape',
  },
];

/** 常见问答 */
export const faqData = [
  {
    question: '香蕉漫画网收录哪些类型的漫画？',
    answer: '香蕉漫画网主要收录韩漫（韩国网络漫画）、日漫（日本漫画）与国漫（国产漫画）三大类，涵盖热血战斗、恋爱校园、悬疑推理、玄幻修真、日常治愈、科幻未来、历史古风、体育竞技等八大细分题材。每个分类都经过精心整理，方便漫迷精准查找。',
  },
  {
    question: '网站的漫画资源是否免费？',
    answer: '香蕉漫画网提供的漫画浏览和分类索引服务完全免费。部分汉化资源由合作汉化组提供，仅供交流学习使用。我们鼓励读者支持正版，喜欢的作品请购买正版漫画或在官方平台订阅，以支持漫画作者的创作。',
  },
  {
    question: '如何快速找到想看的漫画？',
    answer: '你可以通过三种方式快速定位漫画：一是使用顶部搜索栏直接输入漫画名称；二是通过「漫画分类索引」模块按题材、地区、热度筛选；三是关注「焦点专题」中的主题合集，发现同类型优质作品。网站还支持按更新时间和连载状态筛选。',
  },
  {
    question: '发现漫画内容有误或链接失效怎么办？',
    answer: '如果你发现任何内容错误、链接失效或信息过时，请通过「读者投稿与联系」模块提交反馈。我们的编辑团队会在24小时内核实并修复。你也可以通过页面底部的联系邮箱直接发送纠错邮件，邮件标题请注明「纠错」字样。',
  },
  {
    question: '网站的更新频率是怎样的？',
    answer: '香蕉漫画网的更新节奏紧跟各平台连载进度。热门韩漫通常在官方更新后12至24小时内完成汉化上架；日漫跟随Jump等杂志的周刊或月刊周期同步更新；国漫则与腾讯动漫、哔哩哔哩漫画等平台保持紧密同步。每日更新动态会在「最新更新动态」模块实时展示。',
  },
  {
    question: '我可以向网站推荐漫画或投稿吗？',
    answer: '非常欢迎！读者推荐是我们发现优质漫画的重要渠道。你可以通过「读者投稿与联系」模块提交推荐，请提供漫画名称、作者、题材类型和推荐理由。优秀的推荐内容有机会被我们采纳并制作成专题推荐。汉化组合作投稿请详细说明团队信息和既往作品。',
  },
];

/** 品牌介绍 */
export const aboutData = {
  title: '关于香蕉漫画网',
  description: '香蕉漫画网成立于2020年，是国内专注于韩漫、日漫、国漫分类聚合的漫画导航平台。我们致力于为广大漫迷提供精准、高效、干净的漫画阅读导航服务，让国产漫画、日本漫画、韩国漫画的爱好者都能在这里找到属于自己的精神家园。',
  stats: [
    { label: '收录漫画', value: '15,000+' },
    { label: '日更新章节', value: '200+' },
    { label: '合作汉化组', value: '50+' },
    { label: '累计用户', value: '500万+' },
  ],
  image: 'https://readdy.ai/api/search-image?query=Warm%20illustration%20of%20a%20cozy%20reading%20nook%20with%20stacked%20comic%20books%2C%20soft%20lamp%20light%2C%20comfortable%20chair%2C%20banana%20elements%20as%20subtle%20decor%2C%20inviting%20atmosphere%2C%20coral%20and%20cream%20color%20palette%2C%20editorial%20illustration%20style%2C%20modern%20and%20welcoming&width=800&height=500&seq=about-01&orientation=landscape',
};

/** 平台特色 */
export const featuresData = [
  {
    icon: 'ri-compass-3-line',
    title: '精准分类导航',
    description: '韩漫、日漫、国漫三大体系细分八大题材，从热血战斗到日常治愈，快速定位你的心头好，告别漫无目的的翻页。',
  },
  {
    icon: 'ri-time-line',
    title: '实时更新追踪',
    description: '每日精选更新推送，热门连载进度一目了然。关注喜爱的漫画即可在新章节上线时第一时间收到通知。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净阅读体验',
    description: '拒绝弹窗广告与恶意跳转，为漫迷打造清爽干净的浏览环境。页面加载迅速，阅读不被打断。',
  },
  {
    icon: 'ri-group-line',
    title: '活跃漫迷社区',
    description: '数十万漫迷聚集于此，分享读后感、推荐冷门佳作、讨论剧情走向。在香蕉漫画网，找到与你共鸣的阅读伙伴。',
  },
];

/** 热门话题 */
export const topicsData = [
  { name: '韩漫推荐', count: 12580, trending: true },
  { name: '日漫新番', count: 9876, trending: true },
  { name: '国漫崛起', count: 8654, trending: true },
  { name: '恋爱漫画', count: 7432, trending: false },
  { name: '热血战斗', count: 6987, trending: false },
  { name: '悬疑推理', count: 5621, trending: false },
  { name: '漫画汉化', count: 4890, trending: false },
  { name: '穿越异世界', count: 4234, trending: true },
  { name: '治愈系', count: 3891, trending: false },
  { name: '经典完结', count: 3456, trending: false },
  { name: '漫改动画', count: 3123, trending: false },
];

/** 移动端体验 */
export const appData = {
  title: '移动端体验',
  description: '香蕉漫画网移动端适配完善，手机、平板均可获得与桌面端一致的浏览体验。随时随地追更你最爱的韩漫、日漫与国漫。',
  features: ['响应式布局，自动适配各种屏幕', '章节缓存，离线也能继续阅读', '夜间模式，护眼阅读更舒适'],
  image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20mockup%20displaying%20a%20comic%20reader%20app%20interface%2C%20elegant%20phone%20frame%2C%20comic%20pages%20on%20screen%2C%20clean%20minimal%20UI%20design%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20soft%20shadows%2C%20product%20photography%20style%20with%20neutral%20background&width=500&height=700&seq=app-01&orientation=portrait',
};